export default [
    {
      "name": "Choose location...",
      "value": ""
    },
    {
      "name": "Baška Voda",
      "value": "21320"
    },
    {
      "name": "Beli Manastir",
      "value": "31300"
    },
    {
      "name": "Benkovac",
      "value": "23420"
    },
    {
      "name": "Biograd na moru",
      "value": "23210"
    },
    {
      "name": "Bjelovar",
      "value": "43000"
    },
    {
      "name": "Bol",
      "value": "21420"
    },
    {
      "name": "Brinje",
      "value": "53260"
    },
    {
      "name": "Buje (Buie)",
      "value": "52460"
    },
    {
      "name": "Buzet",
      "value": "52420"
    },
    {
      "name": "Cavtat",
      "value": "20210"
    },
    {
      "name": "Crikvenica",
      "value": "51260"
    },
    {
      "name": "Čaglin",
      "value": "34350"
    },
    {
      "name": "Čakovec",
      "value": "40000"
    },
    {
      "name": "Čazma",
      "value": "43240"
    },
    {
      "name": "Daruvar",
      "value": "43500"
    },
    {
      "name": "Delnice",
      "value": "51300"
    },
    {
      "name": "Donja Stubica",
      "value": "49240"
    },
    {
      "name": "Donji Kraljevec",
      "value": "40320"
    },
    {
      "name": "Donji Lapac",
      "value": "53250"
    },
    {
      "name": "Donji Miholjac",
      "value": "31540"
    },
    {
      "name": "Drniš",
      "value": "22320"
    },
    {
      "name": "Dubrovnik",
      "value": "20000"
    },
    {
      "name": "Duga Resa",
      "value": "47250"
    },
    {
      "name": "Dugo Selo",
      "value": "10370"
    },
    {
      "name": "Dvor",
      "value": "44440"
    },
    {
      "name": "Đakovo",
      "value": "31400"
    },
    {
      "name": "Đurđevac",
      "value": "48350"
    },
    {
      "name": "Garešnica",
      "value": "43280"
    },
    {
      "name": "Glina",
      "value": "44400"
    },
    {
      "name": "Gospić",
      "value": "53000"
    },
    {
      "name": "Gradac",
      "value": "21330"
    },
    {
      "name": "Gračac",
      "value": "23440"
    },
    {
      "name": "Grohote",
      "value": "21430"
    },
    {
      "name": "Grubišno Polje",
      "value": "43290"
    },
    {
      "name": "Gunja",
      "value": "32260"
    },
    {
      "name": "Gvozd",
      "value": "44410"
    },
    {
      "name": "Hrvatska Dubica",
      "value": "44450"
    },
    {
      "name": "Hrvatska Kostajnica",
      "value": "44430"
    },
    {
      "name": "Hvar",
      "value": "21450"
    },
    {
      "name": "Imotski",
      "value": "21260"
    },
    {
      "name": "Ivanec",
      "value": "42240"
    },
    {
      "name": "Ivanić-Grad",
      "value": "10310"
    },
    {
      "name": "Jarmina",
      "value": "32280"
    },
    {
      "name": "Jastrebarsko",
      "value": "10450"
    },
    {
      "name": "Karlovac",
      "value": "47000"
    },
    {
      "name": "Kijevo",
      "value": "22310"
    },
    {
      "name": "Klanjec",
      "value": "49290"
    },
    {
      "name": "Knin",
      "value": "22300"
    },
    {
      "name": "Koprivnica",
      "value": "48000"
    },
    {
      "name": "Korenica",
      "value": "53230"
    },
    {
      "name": "Korčula",
      "value": "20260"
    },
    {
      "name": "Krapina",
      "value": "49000"
    },
    {
      "name": "Križevci",
      "value": "48260"
    },
    {
      "name": "Krk",
      "value": "51500"
    },
    {
      "name": "Kutina",
      "value": "44320"
    },
    {
      "name": "Kutjevo",
      "value": "34340"
    },
    {
      "name": "Labin",
      "value": "52220"
    },
    {
      "name": "Lastovo",
      "value": "20290"
    },
    {
      "name": "Lepoglava",
      "value": "42250"
    },
    {
      "name": "Ludbreg",
      "value": "42230"
    },
    {
      "name": "Lučko",
      "value": "10250"
    },
    {
      "name": "Makarska",
      "value": "21300"
    },
    {
      "name": "Mali Lošinj",
      "value": "51550"
    },
    {
      "name": "Metković",
      "value": "20350"
    },
    {
      "name": "Našice",
      "value": "31500"
    },
    {
      "name": "Nova Gradiška",
      "value": "35400"
    },
    {
      "name": "Nova Kapela",
      "value": "35410"
    },
    {
      "name": "Novi Marof",
      "value": "42220"
    },
    {
      "name": "Novi Vinodolski",
      "value": "51250"
    },
    {
      "name": "Novska",
      "value": "44330"
    },
    {
      "name": "Obrovac",
      "value": "23450"
    },
    {
      "name": "Ogulin",
      "value": "47300"
    },
    {
      "name": "Okučani",
      "value": "35430"
    },
    {
      "name": "Omiš",
      "value": "21310"
    },
    {
      "name": "Opatija",
      "value": "51410"
    },
    {
      "name": "Orebić",
      "value": "20250"
    },
    {
      "name": "Oriovac",
      "value": "35250"
    },
    {
      "name": "Osijek",
      "value": "31000"
    },
    {
      "name": "Otočac",
      "value": "53220"
    },
    {
      "name": "Ozalj",
      "value": "47280"
    },
    {
      "name": "Pag",
      "value": "23250"
    },
    {
      "name": "Pakrac",
      "value": "34550"
    },
    {
      "name": "Pazin",
      "value": "52000"
    },
    {
      "name": "Petrinja",
      "value": "44250"
    },
    {
      "name": "Pleternica",
      "value": "34310"
    },
    {
      "name": "Ploče",
      "value": "20340"
    },
    {
      "name": "Podravska Moslavina",
      "value": "31530"
    },
    {
      "name": "Poreč (Parenzo)",
      "value": "52440"
    },
    {
      "name": "Postira",
      "value": "21410"
    },
    {
      "name": "Požega",
      "value": "34000"
    },
    {
      "name": "Pula (Pola)",
      "value": "52100"
    },
    {
      "name": "Rab",
      "value": "51280"
    },
    {
      "name": "Rijeka",
      "value": "51000"
    },
    {
      "name": "Rovinj (Rovigno)",
      "value": "52210"
    },
    {
      "name": "Samobor",
      "value": "10430"
    },
    {
      "name": "Senj",
      "value": "53270"
    },
    {
      "name": "Sesvete",
      "value": "10360"
    },
    {
      "name": "Sinj",
      "value": "21230"
    },
    {
      "name": "Sisak",
      "value": "44000"
    },
    {
      "name": "Sisak-Caprag",
      "value": "44010"
    },
    {
      "name": "Slatina",
      "value": "33520"
    },
    {
      "name": "Slavonski Brod",
      "value": "35000"
    },
    {
      "name": "Slavonski Šamac",
      "value": "35220"
    },
    {
      "name": "Slunj",
      "value": "47240"
    },
    {
      "name": "Solin",
      "value": "21210"
    },
    {
      "name": "Split-ZracnaLuka",
      "value": "21217"
    },
    {
      "name": "Split",
      "value": "21000"
    },
    {
      "name": "Stari Grad",
      "value": "21460"
    },
    {
      "name": "Staro Petrovo Selo",
      "value": "35420"
    },
    {
      "name": "Ston",
      "value": "20230"
    },
    {
      "name": "Strizivojna",
      "value": "31410"
    },
    {
      "name": "Suhopolje",
      "value": "33410"
    },
    {
      "name": "Sunja",
      "value": "44210"
    },
    {
      "name": "Supetar",
      "value": "21400"
    },
    {
      "name": "Sveti Ivan Zelina",
      "value": "10380"
    },
    {
      "name": "Šestanovac",
      "value": "21250"
    },
    {
      "name": "Šibenik",
      "value": "22000"
    },
    {
      "name": "Šibenik-Zablaće",
      "value": "22030"
    },
    {
      "name": "Tisno",
      "value": "22240"
    },
    {
      "name": "Trilj",
      "value": "21240"
    },
    {
      "name": "Trogir",
      "value": "21220"
    },
    {
      "name": "Trpanj",
      "value": "20240"
    },
    {
      "name": "Umag (Umago)",
      "value": "52470"
    },
    {
      "name": "Valpovo",
      "value": "31550"
    },
    {
      "name": "Varaždin",
      "value": "42000"
    },
    {
      "name": "Vela Luka",
      "value": "20270"
    },
    {
      "name": "Velika",
      "value": "34330"
    },
    {
      "name": "Velika Gorica",
      "value": "10410"
    },
    {
      "name": "Veliki Grđevac",
      "value": "43270"
    },
    {
      "name": "Vinkovci",
      "value": "32100"
    },
    {
      "name": "Virovitica",
      "value": "33000"
    },
    {
      "name": "Vis",
      "value": "21480"
    },
    {
      "name": "Višnjevac",
      "value": "31220"
    },
    {
      "name": "Vojnić",
      "value": "47220"
    },
    {
      "name": "Vrbovec",
      "value": "10340"
    },
    {
      "name": "Vrpolje",
      "value": "35210"
    },
    {
      "name": "Vrsar (Orsera)",
      "value": "52450"
    },
    {
      "name": "Vukovar",
      "value": "32000"
    },
    {
      "name": "Vukovar",
      "value": "32010"
    },
    {
      "name": "Zabok",
      "value": "49210"
    },
    {
      "name": "Zadar",
      "value": "23000"
    },
    {
      "name": "Zagreb",
      "value": "10000"
    },
    {
      "name": "Zagreb-Dubrava",
      "value": "10040"
    },
    {
      "name": "Zagreb-Novi Zagreb",
      "value": "10020"
    },
    {
      "name": "Zagreb-Sloboština",
      "value": "10010"
    },
    {
      "name": "Zagreb-Susedgrad",
      "value": "10090"
    },
    {
      "name": "Zagreb-ZracnaLuka",
      "value": "10150"
    },
    {
      "name": "Zagvozd",
      "value": "21270"
    },
    {
      "name": "Zaprešić",
      "value": "10290"
    },
    {
      "name": "Zlatar",
      "value": "49250"
    },
    {
      "name": "Županja",
      "value": "32270"
    }
  ];
